import React from 'react';

const ProductGalleryUrlsSection = ({ urls }) => {
    if (!urls || urls.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Product Gallery Pages</h4>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px'
            }}>
                <div style={{
                    fontSize: '12px',
                    color: '#a0a0a0',
                    textTransform: 'uppercase',
                    marginBottom: '12px',
                    fontWeight: '600',
                    letterSpacing: '0.5px'
                }}>
                    Pages with Product Galleries ({urls.length})
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {urls.map((url, index) => (
                        <a
                            key={index}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: '#60a5fa',
                                textDecoration: 'none',
                                fontSize: '14px',
                                padding: '8px 12px',
                                backgroundColor: '#262626',
                                borderRadius: '4px',
                                border: '1px solid #373737',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#2d2d2d';
                                e.target.style.textDecoration = 'underline';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#262626';
                                e.target.style.textDecoration = 'none';
                            }}
                        >
                            {url}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProductGalleryUrlsSection;

